"use strict";

var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = _interopRequire(require("react"));

var classNames = _interopRequire(require("classnames"));

var BootstrapMixin = _interopRequire(require("./BootstrapMixin"));

var Well = React.createClass({
  displayName: "Well",

  mixins: [BootstrapMixin],

  getDefaultProps: function getDefaultProps() {
    return {
      bsClass: "well"
    };
  },

  render: function render() {
    var classes = this.getBsClassSet();

    return React.createElement(
      "div",
      _extends({}, this.props, { className: classNames(this.props.className, classes) }),
      this.props.children
    );
  }
});

module.exports = Well;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/Well.js
 ** module id = 228
 ** module chunks = 0
 **/